import { Injectable } from '@angular/core';
import { QuickFilterService } from '../filters/filters-api/search/quick-filter-service';
import { SavedViewsService } from '../saved-views/saved-views.service';
import { SiteOptionColumnDropdownService } from './site-options/site-options-column-dropdown/site-option-column-dropdown.service';
import { GroupButtonDropdownService } from './site-options/site-options-group-button/group-button-dropdown/group-button-dropdown.service';
import { SortButtonDropdownService } from './site-options/site-options-sort-button/sort-button-dropdown/sort-button-dropdown.service';
import { SiteOptionsService } from './site-options/site-options.service';
import { CustomTableService } from './site-table/custom-table/custom-table.service';

@Injectable({
  providedIn: 'root',
})
export class ResetTableService {
  constructor(
    private sortButtonDropdownService: SortButtonDropdownService,
    private groupButtonDropdownService: GroupButtonDropdownService,
    private siteOptionColumnDropdownService: SiteOptionColumnDropdownService,
    private siteOptionsService: SiteOptionsService,
    private savedViewsService: SavedViewsService,
    private quickFilterService: QuickFilterService,
    private customTableService: CustomTableService,
  ) {}

  resetTable(workspaceId: string): void {
    this.resetColumns({ workspaceId, resetGroupingAndSorting: true });
    this.resetFilters();
    this.resetSorting();
    this.resetGrouping();
    this.resetSavedViews(workspaceId);
  }

  resetSavedViews(workspaceId: string): void {
    this.savedViewsService.clearWorkspaceSavedViews(workspaceId);
  }

  resetFilters(): void {
    this.quickFilterService.resetFilters();
    this.customTableService.reloadTable();
  }

  resetSorting(): void {
    this.sortButtonDropdownService.removeSorting();
  }

  resetGrouping(): void {
    this.groupButtonDropdownService.removeGrouping();

    const groupButton = this.siteOptionsService.getGroupButton();

    if (groupButton) {
      groupButton.update();
    }
  }

  resetColumns({
    workspaceId,
    resetGroupingAndSorting = false,
  }: {
    workspaceId: string;
    resetGroupingAndSorting?: boolean;
  }): void {
    this.siteOptionColumnDropdownService.resetColumns(resetGroupingAndSorting, workspaceId);
  }
}
